export default __webpack_public_path__ + "static/media/Refresh.a328c907.svg";